import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const EmptyIcon = (props: IconProps) => (
  <Icon width="60px" height="60px" viewBox="0 0 60 60" fill="none" {...props}></Icon>
);
